import { Button } from '~/components/ui/Button';
import type { OrganizationInvite } from '~/types/organization';

interface AcceptInviteScreenProps {
  invite: OrganizationInvite;
  onAccept: VoidFunction;
  onDeny: VoidFunction;
  isAccepting: boolean;
  isDenying: boolean;
}

export const AcceptInviteScreen = ({ invite, onAccept, onDeny, isAccepting, isDenying }: AcceptInviteScreenProps) => (
  <div className="flex flex-col gap-6 h-full items-center justify-center">
    <div className="flex flex-col gap-4 justify-center items-center max-w-80">
      <div className="i-heroicons:envelope text-bolt-ds-text-tertiary w-6 h-6" />
      <div className="text-bolt-ds-text-primary text-base font-semibold text-center">
        You’ve been invited to join <b>{invite.organization.name}</b> team.
      </div>
      <div className="text-bolt-ds-text-secondary text-sm text-center">
        If you accept this request, a new Team account will be created for you, distinct from your individual plan
        holding your personal projects.
      </div>
    </div>
    <div className="flex flex-col gap-4 items-center">
      <Button className="w-60" onClick={onAccept} disabled={isAccepting || isDenying} loading={isAccepting}>
        I understand, accept invitation
      </Button>
      <Button variant="ghost" onClick={onDeny} className="w-60" disabled={isAccepting || isDenying} loading={isDenying}>
        Deny invitation
      </Button>
    </div>
  </div>
);
